// 用来渲染路由
import router from './router/index.js'
import store from '@/store/index.js'
import { Message } from 'view-design'
import NProgress from 'nprogress'
import common from './libs/util.js'
import 'nprogress/nprogress.css'
import { checkProjectVersion } from '@/libs/check-project-version'

router.beforeEach(async (to, from, next) => {
  checkProjectVersion()
  const path = to.fullPath
  if (path.indexOf('login?code') !== -1) {
    const code = common.getQueryString('code', path)
    const state = common.getQueryString('state', path)
    await store.dispatch('getAccessToken', { code: code, state: state })
  }
  const whiteListRoute = ['/login', '/500', '/404', '/shareList', '/register', '/bindMobile', '/resetPassword']
  NProgress.start()
  const token = window.localStorage.getItem('token')
  const expiryTime = window.localStorage.getItem('expiryTime')
  if (token) {
    if (to.fullPath === '/login' || to.fullPath === '/shareList') {
      next()
      NProgress.done()
    } else {
      if (expiryTime && new Date().getTime() - expiryTime < 23 * 60 * 60 * 1000) {
        next()
      } else {
        next('/login')
        return
      }
      const hasRoles = store.state.permission.flag
      // console.log(hasRoles)
      if (hasRoles) {
        next()
        NProgress.done()
      } else {
        try {
          const { roles } = await store.dispatch('permission/getRoles', { root: true }) || []
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          router.addRoutes(accessRoutes)
          next({ ...to, replace: true })
          // if(roles&&(to.fullPath==='/500'||to.fullPath==='/404')){
          //     next({path:'/home',replace: true})
          // }else{
          //     next({ ...to, replace: true })
          // }
        } catch (error) {
          // 抛错
          const errrorMsg = error && `src/permission文件发生错误：${error.toString()}`
          Message.error(errrorMsg || 'Has Error')
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {
    const fullPath = to.fullPath.split('?')[0]
    if (whiteListRoute.indexOf(fullPath) !== -1) {
      next()
    } else {
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js